import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const CustomSwitchStyle = (theme: Theme) => createStyles({
    input : {
        position: 'absolute',
        display: 'none',
        opacity: 0,
        width: 0,
        height: 0,
        userSelect:'none',
        WebkitUserSelect: 'none'
    },
    label : {
        position: 'relative',
        display: 'inline-block',
        width: '60px',
        height: '24px',
        minWidth: '60px',
        userSelect:'none',
        WebkitUserSelect: 'none'
    },
    slider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 2,
        left: 2,
        width: 54,
        height: 18,
        border: `1px solid ${styleColors.blackAlpha18}`,
        borderRadius: '30px',
        backgroundColor: styleColors.white,
        userSelect:'none',
        WebkitUserSelect: 'none'
    },
    thumb : {
        position: 'absolute',
        cursor: 'pointer',
        border: `1px solid ${styleColors.blackAlpha45}`,
        top: 0,
        left: 0,
        width: 22,
        height: 22,
        backgroundColor: styleColors.white,
        transition: '.3s',
        borderRadius: '30px',
        userSelect:'none',
        WebkitUserSelect: 'none'
    }
});



// WEBPACK FOOTER //
// ./src/components/economy/CustomSwitch.style.ts